import { reactive } from "vue";

const index = (window.ticketIndex = {});

const inIndex = (ticket_id) => ticket_id in index;

const createTicket = (ticket_id, ticket) =>
  (index[ticket_id] = reactive({ ticket_id, stock: 0, reserved: 0, ...ticket }));

const updateTicket = (ticket_id, ticket) => Object.assign(index[ticket_id], ticket);

export const useTicket = ({ ticket_id, ...ticket }) =>
  inIndex(ticket_id) ? updateTicket(ticket_id, ticket) : createTicket(ticket_id, ticket);
